import { useEffect, useState } from "react";

const REFRESH_INTERVAL = 60 * 1000;

const useRatePolling = (url, errorMessage) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    let isRequestInProgress = false;

    const fetchRates = async () => {
      if (isRequestInProgress) {
        return;
      }

      isRequestInProgress = true;

      try {
        const response = await fetch(url, {
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error("Failed to fetch rates");
        }

        const responseData = await response.json();

        if (!Array.isArray(responseData)) {
          throw new Error("Invalid rates response");
        }

        setData(responseData);
        setError("");
      } catch (requestError) {
        if (requestError.name !== "AbortError") {
          setError(errorMessage);
        }
      } finally {
        isRequestInProgress = false;

        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      }
    };

    fetchRates();
    const refreshTimer = window.setInterval(fetchRates, REFRESH_INTERVAL);

    return () => {
      window.clearInterval(refreshTimer);
      controller.abort();
    };
  }, [errorMessage, url]);

  return { data, isLoading, error };
};

export default useRatePolling;
